export default __webpack_public_path__ + "static/media/page7Image1.f0ed1477.png";